module.exports = __webpack_public_path__ + "983033b3c81f215d9db844c3392d1f7f.svg";